// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminAttributes = (client) => ({
    /**
     * `POST /admin/attributes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminCreateAttribute
     * @source packages/modules/b2c-core/src/api/admin/attributes/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/attributes", { method: "POST", body, query, headers }),
    /**
     * `POST /admin/attributes/:id/values`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminCreateAttributeValue
     * @source packages/modules/b2c-core/src/api/admin/attributes/[id]/values/route.ts
     */
    createValue: (id, body, query, headers) => client.fetch(buildPath("/admin/attributes/:id/values", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /admin/attributes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminDeleteAttribute
     * @source packages/modules/b2c-core/src/api/admin/attributes/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/admin/attributes/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /admin/attributes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListAttributes
     * @source packages/modules/b2c-core/src/api/admin/attributes/route.ts
     */
    list: (query, headers) => client.fetch("/admin/attributes", { method: "GET", query, headers }),
    /**
     * `GET /admin/attributes/:id/values`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListAttributeValues
     * @source packages/modules/b2c-core/src/api/admin/attributes/[id]/values/route.ts
     */
    listValues: (id, query, headers) => client.fetch(buildPath("/admin/attributes/:id/values", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/attributes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetAttribute
     * @source packages/modules/b2c-core/src/api/admin/attributes/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/admin/attributes/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/attributes/:id/values/:value_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetAttributeValue
     * @source packages/modules/b2c-core/src/api/admin/attributes/[id]/values/[value_id]/route.ts
     */
    retrieveValue: (id, valueId, query, headers) => client.fetch(buildPath("/admin/attributes/:id/values/:value_id", [id, valueId]), { method: "GET", query, headers }),
    /**
     * `POST /admin/attributes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminUpdateAttribute
     * @source packages/modules/b2c-core/src/api/admin/attributes/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/admin/attributes/:id", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/attributes/:id/values/:value_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminUpdateAttributeValue
     * @source packages/modules/b2c-core/src/api/admin/attributes/[id]/values/[value_id]/route.ts
     */
    updateValue: (id, valueId, body, query, headers) => client.fetch(buildPath("/admin/attributes/:id/values/:value_id", [id, valueId]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=attributes.js.map